import React from 'react';

const Radiobutton = (props) => (
	<div className="radio-group">
		<label className="radio-container">
			<input {...props} type="radio" />

			<span className="radio-checkmark"></span>
		</label>
		<span>{props.text}</span>
	</div>
)

export default Radiobutton



// WEBPACK FOOTER //
// ./src/components/form/Radiobutton.js